import { Calendar } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import datePicker from 'vue-bootstrap-datetimepicker';
import moment from 'moment';

Vue.component('meetings-calendar', {
    components: {
        datePicker
    },

	data () {
		return {
            tpOptions: {
                format: 'DD/MM/YYYY HH:mm',
            },

            options: {
                format: 'HH:mm',
            },

			filter: {
				user: null,
                client: null
			},

            createForm: $.extend(true, new Form({
                data: {
                    title: '',
                    client_id: null,
                    days: [],
                    start_time: '',
                    period: 'weekly',
                    start_from : null,
                    end_time: '',
                }
            }), {}),

            editForm: $.extend(true, new Form({
                data: {
                    title: '',
                    client_id: null,
                    days: [],
                    start_time: '',
                    period: 'weekly',
                    start_from : null,
                    end_time: '',
                }
            }), {}),

            createFormClientMeeting: $.extend(true, new Form({
                data: {
                    client_id: null,
                    day: null,
                    emails: '',
                    time: '',
                    length: 30,
                    interval: 2,
                    meeting_via: 'zoom',
                },
            }), {}),

            editFormClientMeeting: $.extend(true, new Form({
                data: {
                    client_id: null,
                    day: null,
                    emails: '',
                    time: '',
                    length: 30,
                    interval: 2,
                    meeting_via: 'zoom',
                },
            }), {}),

            working: false,

            updateId: null,

            daysOfWeek: [
                'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday',
            ],
		};
	},

	mounted () {
		this.calendar = new Calendar(document.getElementById('meetings-calendar'), {
            plugins: [
                interactionPlugin,
                dayGridPlugin,
                timeGridPlugin,
                listPlugin
            ],

            header: {
                left: 'prev,next today',
                center: 'title',
                // right: 'listMonth,timeGridWeek,timeGridDay'
                right: 'dayGridMonth,listMonth'
            },

            defaultView: 'listMonth',

            navLinks: true,

            displayEventTime : true,

            editable: false,

            events: this.getMeetings,

            eventRender (info) {
                if (info.view.type === 'listMonth') {
                    if (info.event.extendedProps.quote_id) {
                        $(info.el).append('<td class="fc-widget-content"><a target="_blank" href="/admin/quotes/edit/' + info.event.extendedProps.quote_id + '" class="badge badge-pill badge-info">#' + info.event.extendedProps.quote_id + '</a></td>');
                        $(info.el).append('<td class="fc-widget-content"><a target="_blank" href="/admin/operations-apps/edit/' + info.event.extendedProps.quote_id + '" class="badge badge-pill badge-info">More Info</a></td>');
                    } else {
                        $(info.el).append('<td class="fc-widget-content"></td>');
                        $(info.el).append('<td class="fc-widget-content"></td>');
                    }

                    if (info.event.extendedProps.client_name) {
                        $(info.el).append('<td class="fc-widget-content"><span class="badge badge-pill badge-success">' + info.event.extendedProps.client_name + '</span></td>');
                    } else {
                        $(info.el).append('<td class="fc-widget-content"></td>');
                    }

                    if (info.event.extendedProps.user) {
                        $(info.el).append('<td class="fc-widget-content"><span class="badge badge-pill badge-danger">' + info.event.extendedProps.user + '</span></td>');
                    } else {
                        $(info.el).append('<td class="fc-widget-content"></td>');
                    }

                    if (info.event.extendedProps.meeting_url && info.event.extendedProps.type === 'meeting') {
                        $(info.el).append('<td class="fc-widget-content"><a href="' + info.event.extendedProps.meeting_url + '" class="badge badge-pill badge-secondary">' + info.event.extendedProps.meeting_via + ' Link</span></td>');
                    } else if (info.event.extendedProps.type === 'block') {
                        $(info.el)
                            .append('<td class="fc-widget-content"><a href="#edit" data-toggle="modal" data-block="' + info.event.id + '" class="badge badge-pill badge-secondary">Edit</span></td>');
                    } else if (info.event.extendedProps.type === 'client-meeting') {
                        $(info.el)
                            .append('<td class="fc-widget-content"><a href="#edit-client-meeting" data-toggle="modal" data-block="' + info.event.id + '" class="badge badge-pill badge-secondary">Edit</span></td>');
                    } else {
                        $(info.el).append('<td class="fc-widget-content"></td>');
                    }

                    setTimeout(() => {
                        $('.fc-widget-header').attr('colspan', 8);
                    }, 100);
                }
            },
        });

		const _this = this;
		$('body').on('shown.bs.modal', '#edit', function (event) {
            const triggerElement = $(event.relatedTarget);

            const blockId = triggerElement.data('block');

            axios.get(`/api/meeting-block/show/${blockId}`).then((block) => {
                _this.updateId = block.data.id;

                _this.editForm.data.title = block.data.title;
                _this.editForm.data.days = block.data.days;
                _this.editForm.data.client_id = block.data.client_id;
                _this.editForm.data.start_time = block.data.start_time;
                _this.editForm.data.end_time = block.data.end_time;
                _this.editForm.data.period = block.data.period;
                _this.editForm.data.start_from = moment(block.data.start_from).toDate();
            });
        });

		$('body').on('shown.bs.modal', '#edit-client-meeting', function (event) {
            const triggerElement = $(event.relatedTarget);

            const blockId = triggerElement.data('block');

            axios.get(`/api/client-meeting/show/${blockId}`).then((block) => {
                _this.updateId = block.data.id;

                _this.editFormClientMeeting.data.meeting_via = block.data.meeting_via;
                _this.editFormClientMeeting.data.client_id = block.data.client_id;
                _this.editFormClientMeeting.data.day = block.data.day;
                _this.editFormClientMeeting.data.time = block.data.time; //moment(block.data.time).toDate();
                _this.editFormClientMeeting.data.length = block.data.length;
                _this.editFormClientMeeting.data.interval = block.data.interval;
                _this.editFormClientMeeting.data.emails = block.data.emails;
            });
        });

        this.calendar.render();
	},

    watch: {
        'createFormClientMeeting.data.client_id': function (val) {
            axios.get(`/api/client-operation-emails?client_id=${val}`).then((response) => {
                this.createFormClientMeeting.data.emails = response.data.map((email) => email.email).join(', ');
            });
        },

        // 'editFormClientMeeting.data.client_id': function (val) {
        //     axios.get(`/api/client-operation-emails?client_id=${val}`).then((response) => {
        //         this.editFormClientMeeting.data.emails = response.data.map((email) => email.email).join(', ');
        //     });
        // },
    },

	methods: {
        handleInput (type, field, value) {
            if (type === 'create') {
                this.createForm.data[field] = value;
                console.log(this.createForm.data[field]);
            } else {
                this.editForm.data[field] = value;
            }
        },

		getMeetings (e) {
			return axios.get('/admin/meetings/data', {
				params: {
					start: e.startStr,
					end: e.endStr,
					...this.filter
				}
			}).then(response => response.data.map(e => ({
                ...e,
                backgroundColor: this.getColour(e),
                borderColor: this.getColour(e)
            })));
		},

        getColour (event) {
            if (event.type === 'availability') {
                return event.is_available ? 'rgb(34, 197, 94)' : 'rgb(239, 68, 68)';
            }

            switch (event.ops_status) {
                case 'pending':
                    return '#ff8484';
                case 'in-progress':
                    return '#FFCC00';
                case 'completed':
                    return '#99CC99';
                case 'reviewing':
                    return '#C3C3E5';
            }
        },

        filterEvents () {
            this.calendar.refetchEvents();
        },

        handleCreate () {
            Http.post(
                `/api/meeting-block/create`,
                this.createForm
            ).then(() => this.calendar.refetchEvents());
        },

        handleUpdate () {
            Http.post(
                `/api/meeting-block/update/${this.updateId}`,
                this.editForm
            ).then(() => this.calendar.refetchEvents());
        },

        handleRemove () {
		    axios.post(`/api/meeting-block/remove/${this.updateId}`).then(() => {
		        $('#edit').modal('hide');
                this.calendar.refetchEvents();
            });
        },

        handleCreateClientMeeting () {
            Http.post(
                `/api/client-meeting/store`,
                this.createFormClientMeeting
            ).then(() => {
                this.calendar.refetchEvents();
                $('#create-meeting').modal('hide');
            });
        },

        handleUpdateClientMeeting () {
            Http.post(
                `/api/client-meeting/update/${this.updateId}`,
                this.editFormClientMeeting
            ).then(() => {
                this.calendar.refetchEvents();
                $('#edit-client-meeting').modal('hide');
            });
        },

        handleRemoveClientMeeting () {
            axios.post(`/api/client-meeting/remove/${this.updateId}`).then(() => {

                $('#edit-client-meeting').modal('hide');
                this.calendar.refetchEvents();
            });
        },
	}
});
